import * as HoverCardPrimitive from "@radix-ui/react-hover-card";

export type HoverCardTriggerProps = HoverCardPrimitive.HoverCardTriggerProps;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

export default HoverCardTrigger;
